module.exports = __webpack_public_path__ + "static/img/plant.6005550.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/virtualoffice/interior/plant.png
// module id = C1df
// module chunks = 0